/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const createItem = () => ({
  documentNumber: "",
  documentDate: "",
  description: "",
  openingValue: "",
  profitShareAdjustment: "",
  differentReportingDateAdjustment: "",
  accountingPolicyAdjustment: "",
  otherEquityAdjustment: "",
  closingValue: "",
});

const createGroup = () => ({
  associateName: "",
  items: [createItem()],
});

export function SaInvestmentDetailedRecordInfo({ formData }) {
  const { values, setFieldValue, containView } = formData;
  const { groups = [] } = values;

  const addGroup = () => {
    setFieldValue("groups", [...groups, createGroup()]);
  };

  const removeGroup = (gIndex) => {
    if (groups.length <= 1) return;
    setFieldValue("groups", groups.filter((_, i) => i !== gIndex));
  };

  const addItem = (gIndex) => {
    const newGroups = [...groups];
    newGroups[gIndex].items.push(createItem());
    setFieldValue("groups", newGroups);
  };

  const removeItem = (gIndex, iIndex) => {
    const newGroups = [...groups];
    if (newGroups[gIndex].items.length <= 1) return;
    newGroups[gIndex].items = newGroups[gIndex].items.filter((_, i) => i !== iIndex);
    setFieldValue("groups", newGroups);
  };

  const handleChangeItem = (gIndex, iIndex, field, val) => {
    const newGroups = [...groups];
    newGroups[gIndex].items[iIndex][field] = val;
    setFieldValue("groups", newGroups);
  };

  const num = (v) => (v && v !== "" && !isNaN(v) ? parseFloat(v) : 0);

  // Auto-calculate closingValue (6) = (1) + (2) + (3) + (4) + (5)
  useEffect(() => {
    const newGroups = groups.map((g) => ({
      ...g,
      items: (g.items || []).map((item) => {
        const val6 =
          num(item.openingValue) +
          num(item.profitShareAdjustment) +
          num(item.differentReportingDateAdjustment) +
          num(item.accountingPolicyAdjustment) +
          num(item.otherEquityAdjustment);

        if (num(item.closingValue) !== val6) {
          return { ...item, closingValue: val6 };
        }
        return item;
      }),
    }));

    if (JSON.stringify(newGroups) !== JSON.stringify(groups)) {
      setFieldValue("groups", newGroups);
    }
  }, [
    JSON.stringify(
      groups.map((g) =>
        g.items.map((i) => [
          i.openingValue,
          i.profitShareAdjustment,
          i.differentReportingDateAdjustment,
          i.accountingPolicyAdjustment,
          i.otherEquityAdjustment,
        ])
      )
    ),
  ]);

  const s = {
    container: { fontFamily: '"Times New Roman", Times, serif', color: "#000", padding: "20px", backgroundColor: "#fff", fontSize: "14px" },
    headerTop: { display: "flex", justifyContent: "space-between", marginBottom: "20px" },
    inputDotted: { border: "none", borderBottom: "1px dotted #000", outline: "none", fontSize: "14px", fontFamily: "inherit", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    inputDottedSmall: { border: "none", borderBottom: "1px dotted #000", outline: "none", width: "40px", fontSize: "14px", fontFamily: "inherit", textAlign: "center", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    titleBox: { textAlign: "center", margin: "20px 0" },
    table: { width: "100%", borderCollapse: "collapse", fontSize: "13px", marginTop: "15px" },
    th: { border: "1px solid #000", padding: "8px 4px", textAlign: "center", fontWeight: "bold", verticalAlign: "middle", backgroundColor: "#f9f9f9" },
    td: { border: "1px solid #000", padding: 0, height: "35px", verticalAlign: "middle" },
    inputTable: { width: "100%", height: "100%", border: "none", outline: "none", padding: "0 4px", fontSize: "13px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableCenter: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "center", fontSize: "13px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableRight: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "right", padding: "0 4px", fontSize: "13px", fontFamily: "inherit", background: "transparent", color: "#000" },
    removeBtn: { border: "none", background: "transparent", color: "red", cursor: "pointer", fontWeight: "bold", fontSize: "16px" }
  };

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "");

  return (
    <SoftBox style={s.container}>
      {/* HEADER */}
      <div style={s.headerTop}>
        <div style={{ width: "60%" }}>
          <div>Đơn vị: <input disabled={containView} style={{ ...s.inputDotted, width: "300px" }} value={values.unit} onChange={(e) => setFieldValue("unit", e.target.value)} /></div>
          <div>Địa chỉ: <input disabled={containView} style={{ ...s.inputDotted, width: "300px" }} value={values.address} onChange={(e) => setFieldValue("address", e.target.value)} /></div>
        </div>
        <div style={{ textAlign: "center", width: "40%" }}>
          <div style={{ fontWeight: "bold" }}>Mẫu số S41b-DN</div>
          <div style={{ fontStyle: "italic", fontSize: "12px" }}>(Kèm theo Thông tư số 99/2025/TT-BTC <br /> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
        </div>
      </div>

      {/* TITLE */}
      <div style={s.titleBox}>
        <h2 style={{ margin: 0, textTransform: "uppercase" }}>SỔ KẾ TOÁN CHI TIẾT THEO DÕI CÁC KHOẢN ĐẦU TƯ VÀO CÔNG TY LIÊN KẾT</h2>
        <div style={{ marginTop: 10 }}>Năm tài chính: <input disabled={containView} style={{ ...s.inputDotted, width: "100px", textAlign: "center" }} value={values.fiscalYear} onChange={(e) => setFieldValue("fiscalYear", e.target.value)} /></div>
      </div>

      {/* TABLE */}
      <div style={{ overflowX: "auto" }}>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={{ ...s.th, width: "100px" }} colSpan={2}>Chứng từ</th>
              <th style={{ ...s.th, width: "200px" }} rowSpan={2}>Diễn giải</th>
              <th style={{ ...s.th, width: "100px" }} rowSpan={2}>Giá trị ghi sổ đầu kỳ (1)</th>
              <th style={s.th} colSpan={4}>Các khoản được điều chỉnh tăng (giảm) giá trị ghi sổ của khoản đầu tư</th>
              <th style={{ ...s.th, width: "100px" }} rowSpan={2}>Giá trị ghi sổ cuối kỳ (6)</th>
              {!containView && <th style={{ ...s.th, width: "40px" }} rowSpan={2}>#</th>}
            </tr>
            <tr>
              <th style={{ ...s.th, width: "50px" }}>Số hiệu</th>
              <th style={{ ...s.th, width: "50px" }}>Ngày tháng</th>
              {/* Row 2 Adjusted Columns */}
              <th style={{ ...s.th, fontSize: "11px" }}>Tương ứng phần sở hữu trong lãi/lỗ (2)</th>
              <th style={{ ...s.th, fontSize: "11px" }}>Báo cáo tài chính lập khác ngày (3)</th>
              <th style={{ ...s.th, fontSize: "11px" }}>Chính sách hợp nhất không thống nhất (4)</th>
              <th style={{ ...s.th, fontSize: "11px" }}>Thay đổi vốn chủ sở hữu khác (5)</th>
            </tr>
            <tr style={{ backgroundColor: "#f0f0f0" }}>
              <th style={s.th}>A</th>
              <th style={s.th}>B</th>
              <th style={s.th}>C</th>
              <th style={s.th}>1</th>
              <th style={s.th}>2</th>
              <th style={s.th}>3</th>
              <th style={s.th}>4</th>
              <th style={s.th}>5</th>
              <th style={s.th}>6</th>
              {!containView && <th style={s.th}></th>}
            </tr>
          </thead>
          <tbody>
            {groups.map((group, gIdx) => (
              <React.Fragment key={gIdx}>
                {/* Group Associate Header */}
                <tr style={{ backgroundColor: "#fafafa" }}>
                  <td colSpan={9} style={{ border: "1px solid #000", padding: "0 8px" }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      <input
                        disabled={containView}
                        style={{ ...s.inputTable, fontWeight: "bold", width: "80%" }}
                        placeholder="Nhập tên Công ty liên kết..."
                        value={group.associateName}
                        onChange={(e) => {
                          const newGroups = [...groups];
                          newGroups[gIdx].associateName = e.target.value;
                          setFieldValue("groups", newGroups);
                        }}
                      />
                      {!containView && (
                        <button type="button" style={s.removeBtn} onClick={() => removeGroup(gIdx)}>×</button>
                      )}
                    </div>
                  </td>
                  {!containView && <td style={s.td}></td>}
                </tr>

                {/* Items within Group */}
                {group.items.map((item, iIdx) => (
                  <tr key={iIdx}>
                    <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.documentNumber} onChange={(e) => handleChangeItem(gIdx, iIdx, "documentNumber", e.target.value)} /></td>
                    <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.documentDate} onChange={(e) => handleChangeItem(gIdx, iIdx, "documentDate", e.target.value)} /></td>
                    <td style={s.td}><input disabled={containView} style={s.inputTable} value={item.description} onChange={(e) => handleChangeItem(gIdx, iIdx, "description", e.target.value)} /></td>
                    <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.openingValue} onChange={(e) => handleChangeItem(gIdx, iIdx, "openingValue", e.target.value)} /></td>
                    <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.profitShareAdjustment} onChange={(e) => handleChangeItem(gIdx, iIdx, "profitShareAdjustment", e.target.value)} /></td>
                    <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.differentReportingDateAdjustment} onChange={(e) => handleChangeItem(gIdx, iIdx, "differentReportingDateAdjustment", e.target.value)} /></td>
                    <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.accountingPolicyAdjustment} onChange={(e) => handleChangeItem(gIdx, iIdx, "accountingPolicyAdjustment", e.target.value)} /></td>
                    <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.otherEquityAdjustment} onChange={(e) => handleChangeItem(gIdx, iIdx, "otherEquityAdjustment", e.target.value)} /></td>
                    <td style={{ ...s.td, textAlign: "right", padding: "0 4px", fontWeight: "bold" }}>{fmt(item.closingValue)}</td>
                    {!containView && (
                      <td style={{ ...s.td, textAlign: "center" }}>
                        <button type="button" style={s.removeBtn} onClick={() => removeItem(gIdx, iIdx)}>–</button>
                      </td>
                    )}
                  </tr>
                ))}

                {!containView && (
                  <tr>
                    <td colSpan={9} style={{ textAlign: "center", padding: "4px" }}>
                      <SoftBox mt={3} textAlign="center">
                        <SoftButton variant="outlined" color="dark" onClick={() => addItem(gIdx)}>
                          + Thêm dòng chi tiết cho nhóm này
                        </SoftButton>
                      </SoftBox>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>

        {!containView && (
          <SoftBox mt={2} textAlign="left">
            <SoftButton variant="outlined" color="dark" onClick={addGroup}>+ Thêm Công ty liên kết mới</SoftButton>
          </SoftBox>
        )}
      </div>

      {/* FOOTER */}
      <div style={{ marginTop: "30px" }}>
        <div>- Sổ này có <input disabled={containView} style={s.inputDottedSmall} value={values.totalPages} onChange={(e) => setFieldValue("totalPages", e.target.value)} /> trang, đánh số từ trang 01 đến trang...</div>
        <div>- Ngày mở sổ: <input disabled={containView} style={{ ...s.inputDotted, width: "150px" }} value={values.openingDate} onChange={(e) => setFieldValue("openingDate", e.target.value)} /></div>
      </div>

      {/* <div style={{ display: "flex", justifyContent: "space-between", marginTop: "30px", textAlign: "center" }}>
        <div style={{ width: "30%" }}>
          <b>Người ghi sổ</b><br/><span style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên)</span>
          <SoftBox mt={8}><input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.ledgerClerk} onChange={(e) => setFieldValue("ledgerClerk", e.target.value)} /></SoftBox>
        </div>
        <div style={{ width: "30%" }}>
          <b>Kế toán trưởng</b><br/><span style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên)</span>
          <SoftBox mt={8}><input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.chiefAccountant} onChange={(e) => setFieldValue("chiefAccountant", e.target.value)} /></SoftBox>
        </div>
        <div style={{ width: "30%" }}>
          <div style={{ fontStyle: "italic", fontSize: "13px" }}>Ngày <input disabled={containView} style={s.inputDottedSmall} value={values.signingDay} onChange={(e) => setFieldValue("signingDay", e.target.value)} /> tháng <input disabled={containView} style={s.inputDottedSmall} value={values.signingMonth} onChange={(e) => setFieldValue("signingMonth", e.target.value)} /> năm <input disabled={containView} style={{ ...s.inputDottedSmall, width: "50px" }} value={values.signingYear} onChange={(e) => setFieldValue("signingYear", e.target.value)} /></div>
          <b>Người đại diện theo pháp luật</b><br/><span style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên, đóng dấu)</span>
          <SoftBox mt={8}><input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.legalRepresentative} onChange={(e) => setFieldValue("legalRepresentative", e.target.value)} /></SoftBox>
        </div>
      </div> */}
    </SoftBox>
  );
}
